import { useSelector } from 'react-redux';
import { ICartItem } from '../interfaces/Cart';
import { RootState } from '../store';

export const useGTM = () => {
    const cartItems = useSelector((state: RootState) => state.checkout.items);
    const totalPriceWithVat = useSelector((state: RootState) => state.checkout.totalPriceWithVat);
    const totalPriceWithoutVat = useSelector((state: RootState) => state.checkout.totalPriceWithoutVat);
    const discountCode = useSelector((state: RootState) => state.checkout.discountCode);
    const paymentMethod = useSelector((state: RootState) => state.checkout.billingPaymentMethod);

    const pushToDataLayer = (eventName: string, data: any) => {
        if ((window as any)?.gtag) {
            (window as any).gtag('event', eventName, { ...data });
        }
    };

    const formatBaseCheckoutParams = () => ({
        value: totalPriceWithVat,
        tax: totalPriceWithVat - totalPriceWithoutVat,
        currency: 'CZK',
        ...(discountCode?.code && { coupon: discountCode.code }),
        items: cartItems?.map((item: ICartItem) => ({
            item_id: item.event?._key,
            item_name: item.event?.title || item.module?.name,
            item_brand: 'Studio W',
            price: item.module?.price_with_vat,
            quantity: item.item?.quantity,
        })),
    });

    const viewItem = (data: any) => {
        pushToDataLayer('view_item', data);
    };

    const addToCart = (data: any) => {
        pushToDataLayer('add_to_cart', data);
    };

    const removeFromCart = (data: any) => {
        pushToDataLayer('remove_from_cart', data);
    };

    const pushBeginCheckout = () => {
        pushToDataLayer('begin_checkout', formatBaseCheckoutParams());
    };

    const pushAddPaymentInfo = () => {
        pushToDataLayer('add_payment_info', { ...formatBaseCheckoutParams(), payment_type: paymentMethod, });
    };

    const pushAddShippingInfo = () => {
        pushToDataLayer('add_shipping_info', formatBaseCheckoutParams());
    };

    const pushPurchase = (orderNumber: number) => {
        pushToDataLayer('purchase', { ...formatBaseCheckoutParams(), transaction_id: orderNumber });
    };

    const pushPurchaseUserData = (data: any) => {
        pushToDataLayer('purchase_user_data', data);
    };

    const pushRecordPlay = (name: string) => {
        pushToDataLayer('record_play', { name });
    };

    const pushStreamView = (name: string, email: string, hasSubscription: boolean) => {
        pushToDataLayer('stream_view', { name, email, hasSubscription });
    };

    return {
        viewItem,
        addToCart,
        removeFromCart,
        pushBeginCheckout,
        pushAddShippingInfo,
        pushAddPaymentInfo,
        pushPurchase,
        pushRecordPlay,
        pushStreamView,
        pushPurchaseUserData,
    };
};
